import React from 'react';
import TwoThreeRows from "../layouts/TwoThreeRows/TwoThreeRows";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import store from "../store";
import {Helmet} from "react-helmet";

const book = () => {
  return (
    <TwoThreeRows
      rows={3}

      mainPanel={
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/booking.html"
        />
      }

      footerPanel={
          <div className="wrapper wrapper--two-three-rows-box">
              <Helmet>
                  {
                      store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                          return row.rowTitle === "Ship" ? row.sections.map((section) => {
                              return section.title === "Book" ? <meta name="description" content={section.content['seo-description']}/> : null
                          }) : null
                      }) : null
                  }
              </Helmet>
          </div>}
    />
  )
};

export default book;



// WEBPACK FOOTER //
// ./src/pages/Book.js